import { z } from 'zod';
import { formSubmissionError } from '@/services/cms/userDefinedForm/formSubmissionError';

export const formSubmissionResponse = z.object({
    errors: z.array(formSubmissionError).optional(),
    message: z.string(),
});

export type FormSubmissionResponse = z.infer<typeof formSubmissionResponse>;
